function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './RangeFilter.css';
import React from 'react';
import { tealiumClickFunc, tealiumMergeClickData } from "../../../../../utils/tealium";
import { get } from "../../../../../utils";
import { DropdownFilterWrapper } from "./DropdownFilterWrapper";
import addQueryString, { deleteQueryString } from '../../../../Listing/index';
import { useHistory } from "react-router-dom";
import { qsToObject } from "../../../../../utils/querystring";
/*eslint-disable */

const createRanges = function (annualFeeRangeObject) {
  let step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50000;
  let isMultiSelect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const annualFeeRangeArr = Object.keys(annualFeeRangeObject);
  return annualFeeRangeArr.map((annualFeeRange, ind) => {
    const index = +annualFeeRange;
    const count = annualFeeRangeObject[annualFeeRange];
    // (N, N+50k-1)
    const from = `${index * step}`;
    const to = `${index * step + step - 1}`;
    const title = `${from} - ${to}`;
    return {
      id: `range${index}`,
      title,
      range: index,
      count
    };
  });
};
const createRangesCompress = function () {
  let rangeObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let step = arguments.length > 1 ? arguments[1] : undefined;
  const rangeList = Object.keys(rangeObject);
  const head = rangeList.filter(range => +range <= 9);
  const tail = rangeList.filter(range => +range > 9);
  const headMap = head.map((range, ind) => {
    const index = +range;
    const count = rangeObject[range];
    const from = `${index * step + (index ? 1 : 0)}`;
    const to = `${index * step + step}`;
    const title = `${from} - ${to}`;
    return {
      id: `range${index}`,
      title,
      range: index,
      count
    };
  });
  const tailOption = {
    id: `range_tail`,
    title: '1000+',
    range: 10,
    count: tail.reduce((acc, next) => acc + rangeObject[next], 0)
  };
  if (tailOption.count) {
    return headMap.concat([tailOption]);
  }
  return headMap;
};
const RangeFilter = _ref => {
  let {
    fields,
    showLabel,
    resultsLabel,
    clearAllLabel,
    facetsStats = {},
    facets,
    queryString,
    nbHits,
    setFilter,
    facetsName,
    indexDropDown,
    firstQuery,
    firstFilter,
    wrapperToggle,
    defaultFacets,
    setSubpanelLabel,
    clearAlllFilters,
    hits = [],
    isMultiSelect = false,
    analytics,
    setStartPage,
    getFilterValue,
    columnsClass = 'col-md-12'
  } = _ref;
  let history = useHistory();
  const checkboxes = /*#__PURE__*/React.createRef();
  const filterName = get(fields, 'name');
  const [ranges, setRanges] = React.useState([]);
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedRange, setSelectedRange] = React.useState({});
  const [date, setdate] = React.useState('');
  const label = get(fields, 'title.jss.value');
  const filterType = get(fields, 'fieldNameItem.item.fieldName.value');
  const [selected, setSelected] = React.useState(label);
  React.useEffect(() => {
    if (queryString === 'maxDelegates') {
      if (firstFilter === true) {
        setRanges(createRangesCompress(defaultFacets, 100));
      } else {}
      if (filterType !== firstQuery && `${filterType}RangeIndex` !== firstQuery) {
        setRanges(createRangesCompress(facets, 100));
      }
    }
    if (facets) {
      if (queryString !== 'maxDelegates') {
        setRanges(createRanges(facets, 50000, isMultiSelect));
      }
    }
  }, [facets, defaultFacets]);
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const urlParams = qsToObject(window.location.href);
      const anualFeeFilter = urlParams['universityPrograms.programs.anualFee'];
      if (anualFeeFilter) {
        const splitedRanges = anualFeeFilter.split('OR');
        let display = [];
        if (splitedRanges.length) {
          const state = {};
          display = splitedRanges.map(currentValue => {
            const [, range] = currentValue.trim().split(':');
            const rangeNmb = +range.replace(/\D/g, '');
            const {
              title
            } = ranges.find(_ref2 => {
              let {
                range
              } = _ref2;
              return range === rangeNmb;
            }) || '';
            state[title] = true;
            return title;
          });
          setSelected(display.join(', '));
          setSelectedRange(state);
        }
      }
    }
  }, [selected]);
  React.useEffect(() => {
    if (Object.keys(selectedRange).length != 0) {
      submitFilter(false, false);
    }
  }, [selectedRange]);
  const onChangeHandler = _ref3 => {
    let {
      target
    } = _ref3;
    const currentFacets = defaultFacets || facets;
    let countOfHits = 0;
    const tmpVal = _objectSpread(_objectSpread({}, selectedRange), {}, {
      [target.value]: target.checked
    });
    isMultiSelect ? setSelectedRange(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [target.value]: target.checked
    })) : setSelectedRange(() => ({
      [target.value]: target.checked
    }));
    for (const range in tmpVal) {
      const itemRValue = tmpVal[range];
      if (itemRValue) {
        for (const itemFacet in currentFacets) {
          const value = currentFacets[itemFacet];
          const [stRange, endRange] = range.split(' - ');
          if (+itemFacet >= +stRange && +itemFacet <= +endRange) {
            countOfHits += value;
          }
        }
      }
    }

    // submitFilter(false);
  };
  const clearFilter = e => {
    setSelected(label);
    setdate('');
    setFilter();
    if (setStartPage) {
      setStartPage(true);
    }
    wrapperToggle(true, false);
    deleteQueryString(queryString, history);
    setSelectedRange({});
    if (typeof checkboxes !== "undefined" && checkboxes.current) {
      const checkboxesArray = checkboxes.current.querySelectorAll('.input-choice');
      for (let i = 0; i <= checkboxesArray.length - 1; i++) {
        checkboxesArray[i].checked = false;
      }
    }
    setIsOpen(false);
    getFilterValue && getFilterValue(fields.name, facetsName, null);
    if (e) {
      e.stopPropagation();
    }
  };
  React.useEffect(() => {
    if (clearAlllFilters) {
      clearFilter();
    }
  }, [clearAlllFilters]);
  const submitFilter = function (closeFilter) {
    let toggleWrapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (toggleWrapper) {
      wrapperToggle(true, closeFilter);
    }
    tealiumClickFunc(tealiumMergeClickData(analytics.filterShowResultsAnalytics, analytics.params));
    let filterArr = [];
    const labelDisplay = [];
    Object.keys(selectedRange).forEach(key => {
      if (selectedRange[key]) {
        isMultiSelect ? labelDisplay.push(key) : labelDisplay[0] = key;
        const curr = ranges.find(function () {
          let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return range.title === key;
        });
        if (isMultiSelect) {
          filterArr.push(`${facetsName}:${curr.range}`);
        } else {
          if (queryString === 'maxDelegates') {
            filterArr[0] = curr.range;
          } else {
            filterArr[0] = `${facetsName}:${curr.range}`;
          }
        }
      }
    });
    const filterString = filterArr.join('+OR+');
    setSelected(filterArr.length ? labelDisplay.join(', ') : label);
    getFilterValue && getFilterValue(fields.name, facetsName, filterString);
    setdate(filterString);
    filterArr.length ? addQueryString(queryString, filterString, history) : deleteQueryString(queryString, history);
    setFilter(date);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement(DropdownFilterWrapper, {
    label: selected,
    defaultLabel: label,
    showLabel: showLabel,
    resultsLabel: resultsLabel,
    open: [isOpen, setIsOpen],
    setStartPage: setStartPage,
    applyFn: closeDropdwn => {
      submitFilter(true);
      closeDropdwn && closeDropdwn();
    }
  }, /*#__PURE__*/React.createElement("ul", {
    className: "range-list range-filter",
    onChange: onChangeHandler,
    ref: checkboxes
  }, /*#__PURE__*/React.createElement("li", {
    className: 'fp__inner-cb'
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("button", {
    className: "body-medium fp__inner-clear cursor-pointer btn--reset",
    onClick: e => {
      clearFilter(e);
      tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
    },
    onKeyPress: e => {
      if (e.which === 13) {
        e.preventDefault();
        clearFilter(e);
        tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
      }
    }
  }, clearAllLabel)), ranges.map((range, index) => {
    if (!range) {
      return null;
    }
    return /*#__PURE__*/React.createElement("li", {
      key: range.id,
      className: "range-item"
    }, /*#__PURE__*/React.createElement("label", {
      className: "fp__inner-label",
      htmlFor: range.id
    }, /*#__PURE__*/React.createElement("input", {
      className: `input-choice ${isMultiSelect ? 'fp__checkbox' : 'fp__radio'}`,
      name: "annual-fee",
      defaultChecked: selectedRange[range.title],
      type: isMultiSelect ? 'checkbox' : 'radio',
      id: range.id,
      value: range.title,
      onChange: () => {
        tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), `${filterName}: ${range.title}`);
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-text"
    }, `${range.title} ${range.count ? `(${range.count})` : ''}`), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-bg"
    })));
  }))));
};
const StyledWrapper = _ref4 => {
  let {
    children,
    columnsClass
  } = _ref4;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${columnsClass}`
  }, children);
};

// export default DropDown;
export default RangeFilter;
const commonStyles = "c4hh2v6";
/*eslint-disable */